(function () {
  'use strict';
  var RESPONSE_TTL = 15 * 60 * 1000;

  function initSection(root, win) {
    if (!root || root.__skContactIntent) return root && root.__skContactIntent;
    var panels = Array.from(root.querySelectorAll('[data-sk-contact-panel]'));
    var buttons = Array.from(root.querySelectorAll('[data-sk-contact-mode]'));
    var switcher = root.querySelector('[data-sk-contact-switch]');
    if (panels.length !== 2 || buttons.length !== 2 || !switcher) return;
    var key = 'skContactIntent:' + root.getAttribute('data-sk-contact-intent');
    var hasResponse = panels.some(function (panel) { return Boolean(panel.dataset.skContactResponse); });
    var mode = 'pre';
    var handlers = [];
    function on(target, event, handler) { target.addEventListener(event, handler); handlers.push(function () { target.removeEventListener(event, handler); }); }
    function choose(next) {
      mode = next;
      panels.forEach(function (panel) {
        var inactive = next !== null && panel.dataset.skContactPanel !== next;
        panel.hidden = inactive;
        panel.disabled = inactive;
      });
      buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.skContactMode === next)); });
    }
    if (hasResponse) {
      // Shopify's native form action carries the distinct form ID as its fragment.
      // If both contact tags expose the same response, show the submitted panel.
      mode = null;
      var hash;
      try { hash = decodeURIComponent(win.location.hash.slice(1)); } catch (_) { hash = ''; }
      panels.forEach(function (panel) {
        var form = panel.closest('form');
        if (hash && (hash === form.id || Array.from(panel.querySelectorAll('[id]')).some(function (node) { return node.id === hash; }))) mode = panel.dataset.skContactPanel;
      });
      if (mode === null) {
        try {
          var saved = JSON.parse(win.sessionStorage.getItem(key));
          if (saved && ['pre', 'post'].indexOf(saved.mode) !== -1 && Date.now() - saved.at >= 0 && Date.now() - saved.at < RESPONSE_TTL) mode = saved.mode;
        } catch (_) { /* Both panels remain usable when storage and fragment are unavailable. */ }
      }
      try { win.sessionStorage.removeItem(key); } catch (_) { /* Optional mode hint only. */ }
    }
    choose(mode);
    switcher.hidden = false;
    if (mode !== null) root.setAttribute('data-sk-contact-ready', '');
    buttons.forEach(function (button) { on(button, 'click', function () { choose(button.dataset.skContactMode); root.setAttribute('data-sk-contact-ready', ''); }); });
    panels.forEach(function (panel) {
      on(panel.closest('form'), 'submit', function () {
        // Store only a short-lived mode hint; never names, email, or message text.
        try { win.sessionStorage.setItem(key, JSON.stringify({ mode: panel.dataset.skContactPanel, at: Date.now() })); } catch (_) { /* Native action fragment is the fallback. */ }
      });
    });
    on(root.ownerDocument, 'click', function (event) {
      var link = event.target.closest && event.target.closest('a[href="#ContactForm"]');
      if (!link || mode !== 'pre') return;
      event.preventDefault();
      root.scrollIntoView({ block: 'start' });
    });
    if (hasResponse && mode !== null) {
      var activePanel = panels.find(function (panel) { return panel.dataset.skContactPanel === mode; });
      var status = activePanel.querySelector('.form-status');
      if (status) status.focus();
    }
    var controller = { choose: choose, destroy: function () {
      handlers.forEach(function (remove) { remove(); });
      choose(null); switcher.hidden = true; root.removeAttribute('data-sk-contact-ready'); delete root.__skContactIntent;
    } };
    root.__skContactIntent = controller;
    if (!hasResponse) {
      try {
        var draft = JSON.parse(win.sessionStorage.getItem('skConciergeDraft:v1'));
        win.sessionStorage.removeItem('skConciergeDraft:v1');
        if (draft && draft.version === 1 && typeof draft.at === 'number' && Date.now() - draft.at >= 0 && Date.now() - draft.at < RESPONSE_TTL && typeof draft.text === 'string' && draft.text.length <= 20000) {
          var pre = panels.find(function (panel) { return panel.dataset.skContactPanel === 'pre'; });
          var message = pre.querySelector('textarea');
          if (message) {
            if (['quick', 'detailed'].indexOf(draft.diagnosis_mode) !== -1) pre.dataset.skConciergeMode = draft.diagnosis_mode;
            choose('pre');
            var note = root.ownerDocument.createElement('p');
            note.setAttribute('role', 'status');
            if (!message.value.trim()) {
              message.value = draft.text;
              message.dispatchEvent(new win.Event('input', { bubbles: true }));
              note.textContent = '選んだ機種・構成と診断条件を入力しました。内容を確認・編集してから送信してください。';
            } else {
              note.textContent = '入力中の文章を残しています。診断内容は下の欄から必要な部分をコピーしてください。';
              var area = root.ownerDocument.createElement('textarea');
              area.readOnly = true; area.value = draft.text; area.setAttribute('aria-label', '引き継いだ診断内容');
              note.appendChild(area);
            }
            message.parentNode.insertBefore(note, message);
          }
        }
      } catch (_) { /* A blocked or expired draft never prevents a normal enquiry. */ }
    }
    return controller;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { initSection: initSection };
  if (typeof document !== 'undefined') {
    function init(scope) {
      if (scope.matches && scope.matches('[data-sk-contact-intent]')) initSection(scope, window);
      scope.querySelectorAll('[data-sk-contact-intent]').forEach(function (root) { initSection(root, window); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-sk-contact-intent]').forEach(function (root) { if (root.__skContactIntent) root.__skContactIntent.destroy(); });
    });
  }
})();
